import React from "react";
import { Link } from "react-router-dom";
// const querystring = require("querystring");

const HomePage  = () => {

//   constructor(props) {
//     console.log(props);
//     super(props);
//   }

    return (
      <form>

        <div class="container-fluid">



            <br />
            <div class="card-deck">
                <div class="card">
                    <div class="card-header">
                        <img class="card-img-top" src="/images/DashboardIcon/Icon/crm.png"
                        style={{width:50}} alt="Card image cap" />
            &nbsp;&nbsp;  CRM
                    </div>
                    <div class="card-body">
					{/*
                    <a href="#">Customers</a><br />
                    <a href="/eqius/crm/customer-create">Create Customer </a><br />
                    <a href="/donor-create">Create Donor </a><br />
                    <a href="/member-create">Create Member </a><br />
                    <a href="/prospect-create">Create Prospect </a><br />
                    <a href="/client-create">Create Client </a><br />

                    <a href="/customer-manage">Manage Customer </a><br />
                    <a href="/donor-manage">Manage Donor </a><br />
                    <a href="/member-manage">Manage Member </a><br />
                    <a href="/prospect-manage">Manage Prospect </a><br />
                    <a href="/client-manage">Manage Client </a><br />

                    <a href="#">Clients</a><br />
                    <a href="#">Prospects</a><br />
                    <a href="#">Donors</a><br />
                    <p class="card-text">Relationship Management</p>
					*/}
                    <a href="/customer-search">My Contacts </a><br />
                    <a href="/customer-search">Customers </a><br />
                    <a href="/donor-search">Donors </a><br />
                    <a href="/member-search">Members </a><br />
                    <a href="/prospect-search">Prospects </a><br />
                    <a href="/client-search">Clients </a><br />

                    </div>
                    {/*
                    <div class="card-footer">
                    <small class="text-muted">Last updated 3 mins ago</small>
                    </div>
                    */}
                </div>
                <div class="card">
            
                   <div class="card-header">
                       <img class="card-img-top" src="/images/DashboardIcon/Icon/crm.png"
        	               style={{width:50}} alt="Card image cap" />
                       &nbsp;&nbsp;
                       Process Governance
                    </div>
                    {/*
		           <img class="card-img-top" src="#" alt="Card image cap" />
	                   <p class="card-text">Business Processes</p>
		           	*/}
                   <div class="card-body">
                     <a href="/phases-and-milestones">Process Timelines (Phases and Milestones)</a><br />
                     <a href="/process-controls">Process Controls</a><br />
                     <a href="/operational-controls">Operational Controls</a><br />   
                    </div>
                    {/*
                    <div class="card-footer">
                    <small class="text-muted">Last updated 3 mins ago</small>
                    </div>
                    */}
                </div>
                <div class="card">
                    <div class="card-header">
                        <img class="card-img-top" src="/images/DashboardIcon/Icon/crm.png"
                        style={{width:50}} alt="Card image cap" />
                        &nbsp;&nbsp; Workflow
                    </div>
                    {/*
                    <img class="card-img-top" src="#" alt="Card image cap" />
                    <p class="card-text">Workflow Management.</p>
                    */}
                    <div class="card-body">
                    	<a href="/search-workflows">Workflows</a><br />
                    	<a href="/search-workflow-cases">Workflow Cases</a><br />
                      	<a href="/workflow-multiqueue-form">Workflow Queues</a><br />
                    	{/*
                    	<a href="/create-workflow-case">Create Workflow Case</a><br />
                	    <a href="/manage-workflow-case">Manage Workflow Case</a><br />
                    	<a href="/create-workflow">Create Workflow</a><br />
                    	<a href="/manage-workflow">Manage Workflow</a><br />
                    	*/}

                    </div>
                    {/*
                    <div class="card-footer">
                    <small class="text-muted">Last updated 3 mins ago</small>
                    </div>
                    */}
                </div>
            </div>
            {/*
            <br />
            <div class="card-deck">
                <div class="card bg-light">
                    <div class="card-header">
                        <img class="card-img-top" src="/images/DashboardIcon/Icon/crm.png"
                        style={{width:50}} alt="Card image cap" />
                        &nbsp;&nbsp; Staffing</div>
                    <img class="card-img-top" src="#" alt="Card image cap" />
                    <div class="card-body">
                    <p class="card-text">Staffing Resources and Tools</p>
                    </div>
                    <div class="card-footer">
                    <small class="text-muted">Last updated 3 mins ago</small>
                    </div>
                </div>

                <div class="card bg-light">
                    <div class="card-header">
                        <img class="card-img-top" src="/images/DashboardIcon/Icon/crm.png"
                        style={{width:50}} alt="Card image cap" />
                        &nbsp;&nbsp; Blog</div>
                    <img class="card-img-top" src="#" alt="Card image cap" />
                    <div class="card-body">
                        <p class="card-text">Create and manage Blogs</p>
                    </div>
                    <div class="card-footer">
                        <small class="text-muted">Last updated 3 mins ago</small>
                    </div>
                </div>

            </div>
        */}
        </div>
      </form>
    );
  
}

export default HomePage; 

